function storageAvailable(type) {
    let storage
    try {
        storage = window[type]
        const x = '__storage_test__'
        storage.setItem(x, x)
        storage.removeItem(x)
        return true
    } catch (e) {
        return e instanceof DOMException && (
            e.code === 22 ||
            e.code === 1014 ||
            e.name === 'QuotaExceededError' ||
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
            (storage && storage.length !== 0)
    }
}

export default function registerMyloginHeader(Alpine) {
    Alpine.data('myloginHeader', () => ({
        openLanguagePicker: false,

        toggleLanguagePicker() {
            this.openLanguagePicker = !this.openLanguagePicker
        },

        closeLanguagePicker() {
            this.openLanguagePicker = false
        },
    }))

    // Priority: localStorage required first, then unsupported IE, then outdated warning (single overlay).
    Alpine.data('myloginCompatibilityModals', () => ({
        /** @type {null | 'storage' | 'ie' | 'outdated'} */
        activeKind: null,

        init() {
            if (!window.Bowser) {
                return
            }

            const parser = window.Bowser.getParser(window.navigator.userAgent)

            const isIE = parser.satisfies({
                ie: '>8',
            })

            const isOutdatedBrowser = parser.satisfies({
                chrome: '<120',
                edge: '<120',
                firefox: '<121',
                opera: '<100',
                safari: '<17',
                samsung_internet: '<23',
            })

            if (!storageAvailable('localStorage')) {
                this.activeKind = 'storage'
            } else if (isIE) {
                this.activeKind = 'ie'
            } else if (isOutdatedBrowser) {
                this.activeKind = 'outdated'
            }
        },

        dismissOutdated() {
            this.activeKind = null
        },
    }))
}
